import PromtsTable from './_table'
import template from './index.pug'
import API from 'js/services/api'

export default Vue.extend({
  template: template(),
  components: {
    PromtsTable
  },
  data() {
    return {
      promts: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('promtsAi.index.title'))
    this.$setBreadcrumbs([
      {label: this.$t('promtsAi.breadcrumbs.promtsAi.index'), route: {}}
    ])
  },
  methods: {
    loadPromts(queryOptions = {}) {
      const accountId = this.$route.params.id
      API.promtsAi.index(accountId, queryOptions).then(({data, meta}) => {
        this.promts = data
        this.meta = meta
      })
    }
  }
})
